/**
 * @file   : FlipCards.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 6:33:33 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import SimpleContainer from '../../../external/components/container/SimpleContainer'
import ACol from '../../../external/components/layout/ACol'
import AGrid from '../../../external/components/layout/AGrid'
import ARow from '../../../external/components/layout/ARow'
import Cont from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import HackMarketingContentWrapper from '../../sharedInternal/container/HackMarketingContentWrapper'
import { isShowCardBack } from '../InfoUtil'
import SectionAd from './SectionAd'
import SectionFlipCard from './SectionFlipCard'
import SectionHeader from './SectionHeader'

const FlipCards = ({ intl, theme, section, infoData, mainConfig }) => {
  const getFlipCard = function (content, cardSize) {
    const showCardBack = isShowCardBack(intl, content, infoData)

    return (
      <SectionFlipCard
        intl={intl}
        theme={theme}
        content={content}
        infoData={infoData}
        showCardBack={showCardBack}
        cardSize={cardSize}
      />
    )
  }

  return (
    <HackMarketingContentWrapper>
      <SimpleContainer>
        <Cont>
          <SectionHeader intl={intl} section={section} infoData={infoData} />
          <AGrid fluid>
            <ARow>
              <ACol xs={12} sm={6} md={6} lg={6}>
                {getFlipCard(section.content[0], '6x')}
              </ACol>
              <ACol xs={12} sm={6} md={6} lg={6}>
                <AGrid fluid>
                  <ARow>
                    <ACol xs={12} sm={12} md={12} lg={12}>
                      {getFlipCard(section.content[1], '3x')}
                    </ACol>
                  </ARow>
                  <ARow>
                    <ACol xs={6} sm={6} md={6} lg={6}>
                      {getFlipCard(section.content[2], '3x')}
                    </ACol>
                    <ACol xs={6} sm={6} md={6} lg={6}>
                      {getFlipCard(section.content[3], '3x')}
                    </ACol>
                  </ARow>
                </AGrid>
              </ACol>
            </ARow>
            <Cont>
              <ARow>
                <ACol xs={6} sm={3} md={3} lg={3}>
                  {getFlipCard(section.content[4], '3x')}
                </ACol>
                <ACol xs={6} sm={3} md={3} lg={3}>
                  {getFlipCard(section.content[5], '3x')}
                </ACol>
                <ACol xs={6} sm={3} md={3} lg={3}>
                  {getFlipCard(section.content[6], '3x')}
                </ACol>
                <ACol xs={6} sm={3} md={3} lg={3}>
                  {getFlipCard(section.content[7], '3x')}
                </ACol>
              </ARow>
            </Cont>
          </AGrid>
        </Cont>
      </SimpleContainer>
      <SectionAd section={section} mainConfig={mainConfig} />
      <Section />
    </HackMarketingContentWrapper>
  )
}

FlipCards.propTypes = {
  intl: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
  mainConfig: PropTypes.object,
}

export default FlipCards
